import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import AbstractButton from '../../../base/toolbox/components/AbstractButton';
import { IconModeratorSettings } from "../../../base/icons/svg";
/**
 * An abstract implementation of a button for accessing moderator settings.
 */
class ModeratorButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.moderatorSettings';
        this.icon = IconModeratorSettings;
        this.label = 'toolbar.moderatorSettings';
    }
}
export default translate(connect()(ModeratorButton));
